export const GET_LIST_SCREEN_SETUP = "GET_LIST_SCREEN_SETUP"
export const GET_LIST_SCREEN_SETUP_SUCCESS = "GET_LIST_SCREEN_SETUP_SUCCESS"
export const GET_LIST_SCREEN_SETUP_FAILED = "GET_LIST_SCREEN_SETUP_FAILED"

export const GET_INBOX_SETUP = "GET_INBOX_SETUP"
export const GET_INBOX_SETUP_SUCCESS = "GET_INBOX_SETUP_SUCCESS"
export const GET_INBOX_SETUP_FAILED = "GET_INBOX_SETUP_FAILED"

export const UPDATE_INBOX_SETUP = "UPDATE_INBOX_SETUP"
export const UPDATE_INBOX_SETUP_SUCCESS = "UPDATE_INBOX_SETUP_SUCCESS"
export const UPDATE_INBOX_SETUP_FAILED = "UPDATE_INBOX_SETUP_FAILED"

export const UPDATE_LIST_SCREEN_SETUP = "UPDATE_LIST_SCREEN_SETUP"
export const UPDATE_LIST_SCREEN_SETUP_SUCCESS =
  "UPDATE_LIST_SCREEN_SETUP_SUCCESS"
export const UPDATE_LIST_SCREEN_SETUP_FAILED = "UPDATE_LIST_SCREEN_SETUP_FAILED"
